import { getRenderingOrder } from 'owa-timestream-store';
import { useProjectId } from 'owa-timestream-asset-sdk';
import isMovingAssets from '../selectors/isMovingAssets';
import getSelectedAssets from '../selectors/getSelectedAssets';

export default function useRenderingOrderWithAssetsBeingMoved() {
    const projectId = useProjectId();
    const includeSelectedAssets = isMovingAssets();
    const renderingOrder = getRenderingOrder(projectId);
    const order = includeSelectedAssets ? [...renderingOrder] : renderingOrder;

    if (includeSelectedAssets) {
        const selectedAssets = getSelectedAssets();
        selectedAssets.forEach(id => {
            if (order.indexOf(id) == -1) {
                order.push(id);
            }
        });
    }

    return order;
}
